// What spend is split by on the AI-usage page — one Group by drives both the cost
// chart's series and the Cost Explorer's rows, so the two always line up.

/** Every Group by, feature-first (the most common lens) — the ONE list the dropdown and the URL schema read. */
export const GROUP_BYS = ['feature', 'team', 'user', 'model', 'provider', 'surface'] as const;
export type GroupBy = (typeof GROUP_BYS)[number];

const GROUP_BY_LABEL: Record<GroupBy, string> = {
  feature: 'Feature',
  team: 'Team',
  user: 'User',
  model: 'Model',
  provider: 'Provider',
  surface: 'Surface',
};

/** Dropdown choices, in `GROUP_BYS` order. */
export const GROUP_BY_OPTIONS: { value: GroupBy; label: string }[] = GROUP_BYS.map((value) => ({
  value,
  label: GROUP_BY_LABEL[value],
}));

export const isGroupBy = (v: string): v is GroupBy => GROUP_BYS.some((g) => g === v);

export const groupByLabel = (g: GroupBy): string => GROUP_BY_LABEL[g];
